import {appAPI} from "../../../api";
import {
    IAcceptInviteData,
    ICreateInviteData,
    ICreateInviteResponse,
    IInvite,
    IInviteInfo,
} from "../../../models/IInvites";

const basePath = "/invites";

/**
 * Все эндпоинты, кроме GET /info, требуют авторизации — это автоматически
 * обеспечит request-интерцептор axios (см. src/api/index.ts).
 *
 * GET /info ходит без токена и должен работать на странице регистрации,
 * куда пользователь ещё не залогинен.
 */
export const invitesAPI = {
    create: async (data: ICreateInviteData): Promise<ICreateInviteResponse> => {
        try {
            const res = await appAPI.post(basePath, data);
            return res.data;
        } catch (e: any) {
            throw new Error(
                e.response?.data?.message ||
                `Ошибка сервера: ${e.response?.status} ${e.response?.statusText}`,
            );
        }
    },

    list: async (): Promise<IInvite[]> => {
        const res = await appAPI.get<IInvite[]>(basePath);
        return res.data;
    },

    revoke: async (id: string): Promise<IInvite> => {
        const res = await appAPI.delete<IInvite>(`${basePath}/${id}`);
        return res.data;
    },

    /**
     * Перевыпуск ссылки + повторная отправка письма.
     *
     * Возвращает ICreateInviteResponse (как create), а НЕ IInvite: бэк
     * генерирует новый raw_token и отдаёт его здесь — это единственный
     * момент, когда фронт видит свежую ссылку (старая инвалидируется).
     */
    resend: async (id: string): Promise<ICreateInviteResponse> => {
        try {
            const res = await appAPI.post<ICreateInviteResponse>(
                `${basePath}/${id}/resend`,
            );
            return res.data;
        } catch (e: any) {
            throw new Error(
                e.response?.data?.message ||
                `Ошибка сервера: ${e.response?.status} ${e.response?.statusText}`,
            );
        }
    },

    /** Публичный — для страницы регистрации по ссылке. */
    info: async (token: string): Promise<IInviteInfo> => {
        try {
            const res = await appAPI.get<IInviteInfo>(`${basePath}/info`, {
                params: {token},
            });
            return res.data;
        } catch (e: any) {
            throw new Error(
                e.response?.data?.message ||
                `Ошибка сервера: ${e.response?.status} ${e.response?.statusText}`,
            );
        }
    },

    /**
     * Принять инвайт. Эндпоинт лежит в /auth/accept-invite — там же, где
     * остальная аутентификация (login/register/logout).
     */
    accept: async (
        data: IAcceptInviteData,
    ): Promise<{ access_token: string }> => {
        try {
            const res = await appAPI.post("/auth/accept-invite", data);
            return res.data;
        } catch (e: any) {
            throw new Error(
                e.response?.data?.message ||
                `Ошибка сервера: ${e.response?.status} ${e.response?.statusText}`,
            );
        }
    },
};